import {useCallback, useContext, useEffect, useState} from "react";
import {AppDataContext} from "../../../App";
import UseApiManager from "../../../core/manager/api";
import MaplibreManager, {OverwriteMode} from "../../../core/manager/maplibre";
import PropTypes from "prop-types";


const SourceName = "tree-dm"

export const LayerName = {
    Circle: {id: "tree-dm-circle-layer", at: 0},
}

const MapTreeDmLayer = ({map, style, visible, onInit}) => {

    const { state } = useContext(AppDataContext)
    const [url, setUrl] = useState()
    const { QueryVectorTileUrl } = UseApiManager()
    const { addVectorSource, addLayer, setVisible, zoomInterpolate, removes } = MaplibreManager()

    useEffect(() => {
        QueryVectorTileUrl(`
        SELECT DISTINCT the_geom_webmercator FROM ${state.env.CLIENT_DM_POINT_TABLE}
        `).then(setUrl)
    }, [state])


    useEffect(() => {
        if (!map || !url) { return }

        setTimeout(initLayer, 500)

        return () => {
            removes(map, {sources: SourceName, layers: LayerName})
        }
    }, [map, style, url])

    const initLayer = useCallback(() => {
        if (!map || !url) { return }

        addVectorSource(map, SourceName, url, OverwriteMode.Rewrite)

        addLayer(map, {
            id: LayerName.Circle.id,
            type: "circle",
            source: SourceName,
            sourceLayer: "layer0",
            paint: {
                circleColor: "#333",
                circleOpacity: 0.3,
                circleRadius: zoomInterpolate({8:0, 10:0.5, 14:2, 18:6}),
            },
            layout: {
                visibility: visible ? "visible": "none",
            }
        }, OverwriteMode.Rewrite)

        setVisible(map, LayerName, visible)
        onInit && onInit()
    }, [map, url, visible, onInit])

    useEffect(() => {
        setVisible(map, LayerName, visible)
    }, [map, style, visible])

    return null
}

MapTreeDmLayer.propTypes = {
    map: PropTypes.any,
    style: PropTypes.object,
    visible: PropTypes.bool,
    onInit: PropTypes.func,
}

export default MapTreeDmLayer
